import { roles } from "../config/roles"

export const checkRouteName = (route) => {
   const role = localStorage.getItem('role')
   const routes = route.split('/')
   if (routes[0] == 'contractorHome' || routes[0] == 'cleanerHome' || routes[0] == 'customerHome')
      return 'Home'
   if (routes[0] == 'profile')
      return 'Profile'
   if (routes[0] == 'editprofile')
      return 'Edit Profile'
   if (routes[0] == 'customerCleaner')
      return 'Cleaners'
   if (routes[0] != null)
      return routes[0][0].toUpperCase() + routes[0].slice(1).replace(/([A-Z])/g, ' $1').trim()
   return null
}

export const getHeaders = () => {
   let token = localStorage.getItem('token');

   return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
   }
}

export const GlobalDebug = (function () {
   var savedConsole = console;
   /**
   * @param {boolean} debugOn
   * @param {boolean} suppressAll
   */
   return function (debugOn, suppressAll) {
      var suppress = suppressAll || false;
      if (debugOn === false) {
         // supress the default console functionality
         // console = {};
         console.log = function () { };
         // supress all type of consoles
         if (suppress) {
            console.info = function () { };
            console.warn = function () { };
            console.error = function () { };
         } else {
            console.info = savedConsole.info;
            console.warn = savedConsole.warn;
            console.error = savedConsole.error;
         }
      } else {
         console = savedConsole;
      }
   };
})();